// extracted by mini-css-extract-plugin
export default {"container":"TextInputForm_container__AtTUv","label":"TextInputForm_label__9wpw5"};